<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
      >
        <material-card
          :loading="loadingSchemas"
          title="Forms"
          color="primary"
        >
          <profile-list
            :items="schemas"
            @select="getForms"
          />
        </material-card>
      </v-col>
      <v-col
        v-if="selectedSchema"
        md="8"
        cols="12"
      >
        <material-card
          :loading="loadingForms"
          :title="selectedSchema.name"
          color="primary"
        >
          <v-data-table
            :key="updateTableKey"
            title="entries"
            :loading="loadingForms"
            :headers="headers"
            :items="answers"
            :items-per-page="10"
          >
            <template v-slot:item.created="props">
              {{ moment(props.item.created).format('DD-MM-YY') }}
            </template>
            <template v-slot:item.delete="props">
              <v-btn
                icon
                @click="() => onFormDelete(props.item.formId)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <template v-slot:actions>
            <v-spacer />
            <vue-json-to-csv
              v-if="selectedSchema && answers && answers.length > 0"
              :json-data="answers"
              :csv-title="selectedSchema.name"
            >
              <v-btn
                color="primary"
              >
                Download
              </v-btn>
            </vue-json-to-csv>
          </template>
        </material-card>
      </v-col>
    </v-row>
    <yes-no-dialog
      ref="yesno"
      @yes="currentDelete"
    />
  </v-container>
</template>

<script>
  import moment from 'moment'
  import ProfileList from '../components/core/ProfileList.vue'
  import VueJsonToCsv from 'vue-json-to-csv'
  import YesNoDialog from '../components/core/YesNoDialog.vue'
  export default {
    components: {
      VueJsonToCsv,
      ProfileList,
      YesNoDialog
    },
    data () {
      return {
        schemas: [],
        selectedSchema: null,
        updateTableKey: 0,
        headers: [],
        answers: [],
        loadingSchemas: false,
        loadingForms: false,
        currentDelete: () => {},
      }
    },
    computed: {
      site: function () {
        return this.$store.state.site
      }
    },
    mounted () {
      this.getSchemas()
    },
    methods: {
      moment,
      getForms (schema) {
        this.selectedSchema = schema
        var headers = [{
          text: 'Date',
          value: 'Date'
        }]
        schema.fields.forEach(field => {
          headers.push({
            text: this.capitalize(field.name),
            value: field.name,
            align: 'right'
          })
        })
        headers.push({
          text: 'Delete',
          value: 'delete',
          align: 'right'
        })
        this.headers = headers

        this.loadingForms = true
        this.api.get('form/' + schema.schemaId)
          .then(result => {
            var entries = result.data
            var answers = []
            entries.forEach(entry => {
              answers.push({
                Date: entry.created,
                formId: entry.formId,
                ...entry.answers
              })
            })
            console.log(answers, headers)
            this.answers = answers
            this.loadingForms = false
            this.updateTableKey++
          }, error => {
            this.loadingForms = false
            this.error = error
          })
      },
      getSchemas () {
        this.loadingSchemas = true
        this.api.get('form/schemas/' + this.site)
          .then(result => {
            var schemas = result.data
            schemas.forEach(schema => {
              schema.sub1 = this.moment(schema.created).format('DD-MM-YY')
            })
            this.schemas = schemas
            this.loadingSchemas = false
          }, error => {
            this.loadingSchemas = false
            this.error = error
          })
      },
      onFormDelete (formId) {
        this.currentDelete = (done) => this.deleteForm(formId, done)
        this.$refs.yesno.open('Delete form', `Are you sure you want to delete this form submission from ${this.selectedSchema.name}?`)
      },
      deleteForm (formId, done) {
        this.api.delete('form/' + this.selectedSchema.schemaId + '/' + formId)
          .then(result => {
            this.getForms(this.selectedSchema)
            done()
          }, error => {
            done()
            this.error = error
          })
      }
    }
  }
</script>
